(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tan-premium-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tan-video-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const videoShell = button.closest('[data-tan-video-shell]');
      const video = videoShell && videoShell.querySelector('video');
      if (!video) return;

      if (video.paused) {
        video.play();
        button.setAttribute('aria-pressed', 'false');
      } else {
        video.pause();
        button.setAttribute('aria-pressed', 'true');
      }
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.35 });

    document.querySelectorAll('.tan-premium__film-card').forEach((card) => observer.observe(card));

    const heroFilm = document.querySelector('.tan-premium__hero-film');
    if (heroFilm) {
      const heroObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (!video) return;
          entry.target.classList.toggle('tan-video-offscreen', !entry.isIntersecting);
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.02 });
      heroObserver.observe(heroFilm);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
